// extracted by mini-css-extract-plugin
var _1 = "Lq7xZhlsM6ZIKJTzs8lA";
var _2 = "Tekdrygmxhqw9V05H2aR";
export { _1 as "root", _2 as "title" }
